import ApiService from "./api.service";

class NavService extends ApiService {
    groups() {
        return this.get("/groups");
    }
}

export default new NavService();
